import { TableRow, TableCell, CircularProgress } from '@mui/material';

const TableLoadingState = ({ colSpan }) => (
  <TableRow>
    <TableCell colSpan={colSpan} align='center' sx={{ py: 8 }}>
      <CircularProgress />
    </TableCell>
  </TableRow>
);

export default TableLoadingState;
